import {
    AfterViewInit,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    Output
} from '@angular/core';

import { ReplaySubject } from 'rxjs';
import { take } from 'rxjs/operators';

import { CommonModule } from '@angular/common';
import { SharedLanguageService } from '@language';
import { UrlBuilderService } from '../../../../../core/common/services/url-builder.service';
import { PreviewStatus } from '../../../../../core/records/entities/metadata/metadata.entity';
import { ShListRowTitleComponent, ShMediaBlockComponent } from '../../../../../elements/public_api';
import { ShBaseCell } from '../_base/base-cell.component';
import { MediaCell } from './media-cell.entity';

@Component({
    standalone: true,
    selector: 'sh-media-cell',
    templateUrl: './media-cell.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, ShListRowTitleComponent, ShMediaBlockComponent]
})
export class ShMediaCellComponent extends ShBaseCell implements AfterViewInit {
    public dragData$: ReplaySubject<string> = new ReplaySubject<string>(1);

    @Input() public cell!: MediaCell;
    @Output() cellEvent: EventEmitter<Event> = new EventEmitter<Event>();

    constructor(
        private readonly urlBuilder: UrlBuilderService,
        private readonly cd: ChangeDetectorRef,
        private readonly translateService: SharedLanguageService
    ) {
        super();
    }

    ngAfterViewInit(): void {
        this.initDragDataStream();

        this.cd.detectChanges();
    }

    private initDragDataStream(): void {
        if (this.cell.detailUrl) {
            this.urlBuilder
                .buildDetailUrl(this.cell.detailUrl)
                .pipe(take(1))
                .subscribe(url => this.dragData$.next(url));
        }
    }

    public onMediaClick(event: Event): void {
        const targetClasses: DOMTokenList = (event.target as HTMLInputElement).classList;

        if (targetClasses.contains('sh-contained-media__media')) {
            this.cellEvent.next(event);
            event.stopPropagation();
        }
    }

    public get hasPreviewError(): boolean {
        return this.cell.previewStatus === PreviewStatus.Error;
    }

    public get isProcessing(): boolean {
        return this.cell.previewStatus === PreviewStatus.Processing;
    }

    public get showPlaceholder(): boolean {
        return this.hasPreviewError || this.isProcessing;
    }

    public get placeholderMessage(): string {
        switch (this.cell?.previewStatus) {
            case PreviewStatus.Processing:
                return this.translateService.translate('overrides.RecordStatus.Processing');
            case PreviewStatus.Error:
                return this.translateService.translate('overrides.RecordStatus.Rejected');
            default:
                return '';
        }
    }
}
